import moment from "moment";
import { clsx } from 'clsx';

const EventTicketPageItem = ({ item, qty, onChangeQty }) => {
    const salesEndsAt = moment(item.sales_ends_at);
    const quantity_available = item.quantity_available - item.tickets_sold_count;

    return  (
        <div className={`px-4 py-3 rounded-md border border-neutral-200`}>
            <div className={`flex items-center`}>
                <h3 className={`text-base font-medium text-gray-700`}>{item.type}</h3>
                <div className={`ml-auto flex items-center`}>
                    <button
                        onClick={() => onChangeQty && onChangeQty(-1)}
                        className={clsx(
                            `text-lg font-bold w-9 h-9 bg-neutral-200 rounded-md`,
                            qty > 0 && `!bg-orange-500 text-white`
                        )}
                        disabled={qty === 0}
                    >&minus;</button>
                    <span className={`font-bold text-lg text-gray-600 w-9 text-center`}>{qty}</span>
                    <button
                        onClick={() => onChangeQty && onChangeQty(1)}
                        className={clsx(
                            `text-lg font-bold w-9 h-9 bg-neutral-200 rounded-md`,
                            qty < quantity_available && `!bg-orange-500 text-white`
                        )}
                        disabled={qty === quantity_available}
                    >&#043;</button>
                </div>
            </div>
            <div className={`border-t border-gray-200 mt-4 pt-3 pb-1`}>
                <div className={`flex items-center`}>
                    <h3 className={`text-lg font-bold text-gray-700`}>{item.price}F CFA</h3>
                    <span className={`py-2 px-4 rounded-2xl bg-orange-500 text-white text-xs ml-2`}>
                        {quantity_available} restants
                    </span>
                    <span className={`ml-auto text-xs text-gray-600`}>Fin des ventes {salesEndsAt.fromNow()}</span>
                </div>
                {item.description ? (
                    <p className={`mt-4 text-sm text-gray-600 bg-neutral-100 p-3 rounded-md`}>
                        {item.description}
                    </p>
                ) : null}
            </div>
        </div>
    );
};

export default EventTicketPageItem;